/**
 * Australian mobile normalisation — the client-side mirror of the comms
 * service's `core/phone.py` (sm4rt_emailer).
 *
 * Used for immediate feedback in the SMS composer. The server normalises and
 * re-validates independently; this never becomes the only check.
 */

const PUNCTUATION = /[\s()\-.–—]/g;
const NSN_MOBILE = /^4\d{8}$/;

/**
 * Normalise to E.164 (`+614XXXXXXXX`), or return null when the number isn't a
 * valid Australian mobile (landlines, 13/1300/1800 and overseas numbers all
 * return null — SMS can't reach them).
 */
export function normaliseAuMobile(raw: string | null | undefined): string | null {
  if (!raw || !raw.trim()) return null;

  let value = raw.trim().replace(PUNCTUATION, '');
  if (value.startsWith('+')) value = value.slice(1);
  else if (value.startsWith('0011')) value = value.slice(4);

  if (!/^\d+$/.test(value)) return null;

  let nsn: string;
  if (value.startsWith('61') && value.length > 9) nsn = value.slice(2);
  else if (value.startsWith('0')) nsn = value.slice(1);
  else nsn = value;

  return NSN_MOBILE.test(nsn) ? `+61${nsn}` : null;
}

/** Display form of a normalised number: `+61412345678` → `0412 345 678`. */
export function formatAuMobile(e164: string): string {
  const nsn = e164.replace(/^\+61/, '');
  if (nsn.length !== 9) return e164;
  return `0${nsn.slice(0, 3)} ${nsn.slice(3, 6)} ${nsn.slice(6)}`;
}
